export const quesMap = {
  SINGLECHOICE: "单选题",
  MULTIPLECHOICE: "多选题",
  JUDGMENT: "判断题",
  BLANKFILL: "填空题",
  ESSAY: "问答题",
  MCJST: "名词解释题",
  LST: "论述题",
  JDT: "简答题",
  TT: "套题",
};

export const quesStatus = {
  RAFT: "草稿",
  DISABLED: "禁用",
  ENABLE: "启用",
};

export const difficulty = {
  A: "非常容易",
  B: "比较容易",
  C: "常规",
  D: "较难",
  E: "非常难",
};

export const zwOptions = [
  { label: "无", value: "WU" },
  { label: "办事员", value: "BSY" },
  { label: "科员", value: "KY" },
  { label: "正科（局）", value: "ZK" },
  { label: "副科（局）", value: "FK" },
  { label: "正处（县）", value: "ZC" },
  { label: "正厅", value: "ZT" },
  { label: "副厅", value: "FT" },
  { label: "正部", value: "ZB" },
  { label: "副部", value: "FB" },
  { label: "厅局级正职", value: "TZ" },
  { label: "厅局级副职", value: "TF" },
  { label: "县处级正职", value: "CZ" },
  { label: "县处级副职", value: "CF" },
  { label: "乡科级正职", value: "XZ" },
  { label: "乡科级副职", value: "XF" },
  { label: "一级巡视员", value: "XSY1" },
  { label: "二级巡视员", value: "XSY2" },
  { label: "一级调研员", value: "DYY1" },
  { label: "二级调研员", value: "DYY2" },
  { label: "三级调研员", value: "DYY3" },
  { label: "四级调研员", value: "DYY4" },
  { label: "一级主任科员", value: "ZRKY1" },
  { label: "二级主任科员", value: "ZRKY2" },
  { label: "三级主任科员", value: "ZRKY3" },
  { label: "四级主任科员", value: "ZRKY4" },
  { label: "一级科员", value: "KY1" },
  { label: "二级科员", value: "KY2" },
  { label: "工勤", value: "GQ" },
  { label: "事业干部", value: "SYGB" },
  { label: "其他", value: "QT" }
]

export const politicstOptions = [
  { label: "群众", value: "QZ"}, 
  { label: "共青团员", value: "GQTY"}, 
  { label: "预备党员", value: "YBDY"}, 
  { label: "中共党员", value: "ZGDY"}, 
  { label: "民族党派", value: "MZDP"}
]

export const zcOptions = [ 
  { label: "无", value: "WU"},  
  { label: "初级职称", value: "CJ"},  
  { label: "中级职称", value: "ZJ"},  
  { label: "副高级职称", value: "FGJ"},  
  { label: "正高级职称", value: "ZGJ"},  
  { label: "助理级职称", value: "ZLJ"}
]

export const eduOptions = [ 
  { label: "无", value: "WU"},  
  { label: "中专或相当学历", value: "ZHONGZHUAN"},  
  { label: "大专或相当学历", value: "DAZHUNAN"},  
  { label: "本科", value: "BENKE"},  
  { label: "双学士", value: "SHUANGXUESHI"},  
  { label: "硕士", value: "SHUOSHI"},  
  { label: "博士", value: "BOSHI"},  
  { label: "博士后", value: "BOSHIHOU"},  
  { label: "研究生（未取得学位）", value: "YANJIUSHENG"},  
  { label: "高中", value: "GAOZHONG"},  
  { label: "初中", value: "CHUZHONG"},  
  { label: "小学", value: "XIAOXUE"}
]

export const education = {
  WU: '无',
  ZHONGZHUAN: '中专或相当学历',
  DAZHUNAN: '大专或相当学历',
  BENKE: '本科',
  SHUANGXUESHI: '双学士',
  SHUOSHI: '硕士',
  BOSHI: '博士',
  BOSHIHOU: '博士后',
  YANJIUSHENG: '研究生（未取得学位）',
  GAOZHONG: '高中',
  CHUZHONG: '初中',
  XIAOXUE: '小学',
}
export const quesState = {
  NOTSTART: '未开始',
  STARTED: '进行中',
  SUBMITTED: '已提交',
  AUTOMATIC_REVISED: '已自动批改',
  MANUAL_REVISED: '已手动批改',
  CLOSED: '已关闭',
  EFFECT: '已生效',
}
export const categoryMap = {
  HOMEWORK: "平时作业",
  EXAMINE: "结业考试",
  PRACTICE: "课程练习",
}
export const sex = {
  M: "男",
  F: "女",
}
export const isQua = {
  1: "是",
  0: "否",
}
export const schoolQuality = {
  '1':'公办',
  '2':'民办',
}

export const orderStatus = {
  'WZF':'未支付',
  'YZF':'已支付',
  'YFH':'已发货',
}

export const hoursApplyStatus = {
  '1': "待一审",
  '2': "待终审",
  '3': "终审通过",
  '-1': "一审不通过",
  '-2': "终审不通过",
};

